export const VOICE_INPUT_IDLE = 'idle';
export const VOICE_INPUT_AWAITING_PERMISSION = 'awaiting_permission';
export const VOICE_INPUT_RECORDING = 'recording';
export const VOICE_INPUT_ERROR = 'error';
export const VOICE_INPUT_ERROR_PERMISSION_DENIED = 'permission_denied';